module.exports = __webpack_public_path__ + "static/media/nose.df9c98ca.m4a";